<script setup>
import {onMounted} from "vue";
import {useRoute} from "vue-router";
import {Api} from "@/service/api";


const route = useRoute()

onMounted(async() => {
    const hashParams = parseHashParams(route.hash)
    console.log(hashParams)
    try {
        await Api.AttachYandexAccount(hashParams)
    } catch (error) {
        console.log(error)
    } finally {
        window.close()
    }

})

function parseHashParams(hash) {
    const hashString = hash.substring(1) // убираем #
    const params = {}

    hashString.split('&').forEach(pair => {
        const [key, value] = pair.split('=')
        params[key] = decodeURIComponent(value || '')
    })

    return params
}

</script>

<template>
    <div>

    </div>
</template>

<style scoped>

</style>